import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const path = '../oldPages/insert-management/edit/step1/index.html';

const links: Record<string, string> = {
  insert: '/infoTrac/insert-management',
  submit: '/infoTrac/insert-management?act=saved',
  nextStep: '/infoTrac/insert-management/step2',
};

function InsertManagementEditStep1() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const description = searchParams.get('description');

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const descInput = iframeDocument.getElementById('desc') as HTMLInputElement | null;
      if (descInput && description) {
        descInput.value = description;
      }

      const insert = iframeDocument.getElementsByClassName('insert-management');
      const submit = iframeDocument.getElementsByClassName('saveBtn');
      const nextStep = iframeDocument.getElementsByClassName('next-step');

      if (insert.length) {
        for (let i = 0; i < insert.length; i++) {
          insert[i].addEventListener('click', () => navigate(links.insert));
        }
      }

      if (submit.length) {
        for (let i = 0; i < submit.length; i++) {
          submit[i].addEventListener('click', () => navigate(links.submit));
        }
      }

      if (nextStep.length) {
        for (let i = 0; i < nextStep.length; i++) {
          nextStep[i].addEventListener('click', () => navigate(links.nextStep));
        }
      }
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, [description, navigate]);

  return <iframe ref={iframeRef} title="insert-management-edit-step-1" src={path} width="100%" height="700px" />;
}

export default InsertManagementEditStep1;
